import { createAction } from 'typesafe-actions';

import { RequestErrorData } from '../../types/requests';

export const axiosInterceptorActions = {
  setRequestError: createAction('api/REQUEST_ERROR')<RequestErrorData | null>(),
  setSomeApiFetching: createAction('api/SOME_REQUESTS_FETCHING')<boolean>(),
  setApiCausedPageError: createAction('api/REQUEST_ERROR_CAUSE_PAGE_ERROR')<boolean>(),
};
